/* FreshSmile global scripts: header, cart drawer, quick add, quantity, recently viewed.
   No frameworks, no external dependencies. All user-facing strings come from
   the [data-theme-strings] JSON block rendered in theme.liquid. */
(function () {
  'use strict';

  var strings = {};
  var stringsEl = document.querySelector('[data-theme-strings]');
  if (stringsEl) {
    try { strings = JSON.parse(stringsEl.textContent); } catch (e) { strings = {}; }
  }

  function t(key, fallback) {
    return strings[key] || fallback || '';
  }

  function announce(message) {
    var region = document.querySelector('[data-live-region]');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(function () { region.textContent = message; }, 50);
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = document.body.getAttribute('data-money-format') || '${{amount}}';
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  /* --- Sticky header shadow ------------------------------------------------ */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    }, { passive: true });
  }

  /* --- Mobile navigation --------------------------------------------------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var navWrap = document.querySelector('[data-nav-wrap]');
  if (navToggle && navWrap) {
    navToggle.addEventListener('click', function () {
      var open = navWrap.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && navWrap.classList.contains('is-open')) {
        navWrap.classList.remove('is-open');
        navToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        navToggle.focus();
      }
    });
  }

  /* --- Header search ------------------------------------------------------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-header-search]');
  if (searchToggle && searchBar) {
    var searchClose = searchBar.querySelector('[data-search-close]');
    var searchInput = searchBar.querySelector('input[type="search"]');
    function closeSearch() {
      searchBar.classList.remove('is-open');
      searchToggle.setAttribute('aria-expanded', 'false');
      searchToggle.focus();
    }
    searchToggle.addEventListener('click', function () {
      var open = searchBar.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && searchInput) searchInput.focus();
    });
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    searchBar.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSearch();
    });
  }

  /* --- Cart drawer ---------------------------------------------------------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var lastFocused = null;

  function trapFocus(container, event) {
    var focusable = container.querySelectorAll('a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  function bindDrawer() {
    drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-close]') || event.target.closest('[data-cart-overlay]')) {
        closeDrawer();
      }
      var removeBtn = event.target.closest('[data-line-remove]');
      if (removeBtn) {
        event.preventDefault();
        changeLine(removeBtn.getAttribute('data-line-remove'), 0, removeBtn.closest('.cart-line'));
      }
    });
    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
      if (event.key === 'Tab' && drawer.classList.contains('is-open')) trapFocus(drawer, event);
    });
    drawer.addEventListener('change', function (event) {
      var input = event.target.closest('[data-line-qty]');
      if (input) {
        changeLine(input.getAttribute('data-line-qty'), parseInt(input.value, 10) || 0, input.closest('.cart-line'));
      }
    });
  }
  bindDrawer();

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-open]');
    if (trigger && drawer) {
      event.preventDefault();
      openDrawer();
    }
  });

  function refreshCartUI(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (html && drawer) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var fresh = wrapper.querySelector('[data-cart-drawer]');
          if (fresh) {
            var wasOpen = drawer.classList.contains('is-open');
            drawer.replaceWith(fresh);
            bindDrawer();
            if (wasOpen || openAfter) openDrawer();
          }
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.setAttribute('data-count', cart.item_count);
        });
        updateShippingBars(cart.items_subtotal_price);
        return cart;
      });
  }

  function updateShippingBars(subtotalCents) {
    document.querySelectorAll('[data-shipping-bar]').forEach(function (bar) {
      var thresholdCents = parseInt(bar.getAttribute('data-threshold'), 10) * 100;
      if (!thresholdCents) return;
      var label = bar.querySelector('.shipping-bar__label');
      var progress = bar.querySelector('.shipping-bar__progress');
      var remaining = thresholdCents - subtotalCents;
      var pct = Math.max(0, Math.min(100, (subtotalCents / thresholdCents) * 100));
      if (progress) progress.style.width = pct + '%';
      bar.classList.toggle('is-reached', remaining <= 0);
      if (label) {
        label.textContent = remaining <= 0
          ? t('freeShippingReached', 'Your order qualifies for free shipping.')
          : t('freeShippingRemaining', 'Add {{ amount }} more for free shipping.').replace('{{ amount }}', formatMoney(remaining));
      }
    });
  }

  function changeLine(lineKey, quantity, lineEl) {
    if (lineEl) lineEl.classList.add('is-updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return refreshCartUI(false);
      })
      .then(function () { announce(t('cartUpdated', 'Cart updated.')); })
      .catch(function () {
        if (lineEl) lineEl.classList.remove('is-updating');
        announce(t('cartError', 'There was a problem updating your cart.'));
      });
  }

  function addToCart(body, button) {
    var originalText = button ? button.textContent : '';
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.textContent = t('adding', 'Adding…');
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || 'cart');
          return data;
        });
      })
      .then(function () {
        announce(t('addedToCart', 'Item added to your cart.'));
        if (drawer) {
          return refreshCartUI(true);
        }
        window.location.href = '/cart';
      })
      .catch(function (error) {
        announce(error.message || t('cartError', 'There was a problem updating your cart.'));
        window.alert(error.message || t('cartError', 'There was a problem updating your cart.'));
      })
      .finally(function () {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.textContent = originalText;
        }
      });
  }

  /* Intercept product forms for AJAX add-to-cart when the drawer exists */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-product-form]');
    if (!form || !drawer) return;
    event.preventDefault();
    var formData = new FormData(form);
    var body = {
      id: parseInt(formData.get('id'), 10),
      quantity: parseInt(formData.get('quantity'), 10) || 1
    };
    addToCart(body, form.querySelector('[data-atc-button]'));
  });

  /* Quick add buttons (single-variant products) */
  document.addEventListener('click', function (event) {
    var quickAdd = event.target.closest('[data-quick-add]');
    if (!quickAdd) return;
    event.preventDefault();
    var variantId = parseInt(quickAdd.getAttribute('data-quick-add'), 10);
    if (!variantId) return;
    addToCart({ id: variantId, quantity: 1 }, quickAdd);
  });

  /* --- Quantity steppers ----------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 1;
    var next = (parseInt(input.value, 10) || min) + step;
    if (next < min) next = min;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --- Recently viewed (localStorage) ----------------------------------------- */
  var RECENT_KEY = 'freshsmile:recently-viewed';

  function readRecent() {
    try { return JSON.parse(window.localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; }
  }

  var currentProduct = document.querySelector('[data-product-handle]');
  if (currentProduct) {
    var handle = currentProduct.getAttribute('data-product-handle');
    var recent = readRecent().filter(function (h) { return h !== handle; });
    recent.unshift(handle);
    try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(recent.slice(0, 8))); } catch (e) { /* storage unavailable */ }
  }

  document.querySelectorAll('[data-recently-viewed]').forEach(function (container) {
    var excludeHandle = container.getAttribute('data-exclude');
    var limit = parseInt(container.getAttribute('data-limit'), 10) || 4;
    var handles = readRecent().filter(function (h) { return h !== excludeHandle; }).slice(0, limit);
    if (!handles.length) return;
    var grid = container.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '?view=card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (cards) {
      var html = cards.join('');
      if (!html.trim()) return;
      grid.innerHTML = html;
      container.classList.add('has-items');
    });
  });

  /* Initialize shipping bars from server-rendered subtotal */
  var initialSubtotal = document.querySelector('[data-cart-subtotal-cents]');
  if (initialSubtotal) {
    updateShippingBars(parseInt(initialSubtotal.getAttribute('data-cart-subtotal-cents'), 10) || 0);
  }
})();
